import gql from "graphql-tag";
const BASE_CONTACTS_LOOKUP = gql`
	query (
		$onlyActive: Boolean
		$where: BaseContactFilterInput
		$order: [BaseContactSortInput!]
		$skip: Int
		$take: Int
	) {
		baseContacts(
			onlyActive: $onlyActive
			where: $where
			order: $order
			skip: $skip
			take: $take
		) {
			__pageInfo: pageInfo {
				hasNextPage
			}
			__items: items {
				id
				name
			}
		}
	}
`;
const SURVEY_BY_ID = gql`
	query ($id: UUID!) {
		surveyById(id: $id) {
			id
			name
			settings
		}
	}
`;
const SURVEY_BY_AUDIENCE_ID = gql`
	query ($id: UUID!) {
		surveyByAudienceId(id: $id) {
			id
			name
			settings
		}
	}
`;
const MANAGED_SURVEY_BY_ID = gql`
	query ($id: UUID!) {
		managedSurveyById(id: $id) {
			id
			name
			settings
		}
	}
`;
gql`
	query ($where: SurveyFilterInput) {
		managedSurveys(where: $where) {
			items {
				accesses {
					contact {
						id
						name
					}
				}
			}
		}
	}
`;
const MANAGED_SURVEY_AUDIENCE = gql`
	query ($where: SurveyFilterInput) {
		managedSurveys(where: $where) {
			items {
				name
				isTemplate
				audience {
					id
					createdOn
					name
					key
					tag
					email
					statusId
					isRepeatedly
					numberOfResponses
					lastResponseDate
				}
			}
		}
	}
`;
gql`
	query {
		surveys {
			totalCount
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
			items {
				id
				name
				description
				createdOn
			}
		}
	}
`;
gql`
	query {
		surveys: incompleteSurveys {
			totalCount
			items {
				id
			}
		}
	}
`;
const MANAGED_SURVEYS = gql`
	query (
		$where: SurveyFilterInput
		$order: [SurveySortInput!]
		$skip: Int
		$take: Int
	) {
		managedSurveys(where: $where, order: $order, skip: $skip, take: $take) {
			totalCount
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
			items {
				id
				name
				createdOn
				createdBy {
					id
					name
				}
				isTemplate
				isAnonymous
				dontUseInPortal
				startDate
				endDate
				statusId
				numberOfAudience
				numberOfResponses
				lastResponseDate
				accesses {
					contact {
						id
						name
					}
				}
			}
		}
	}
`;
const MANAGED_SURVEYS_LOOKUP = gql`
	query {
		items: managedSurveys {
			totalCount
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
			items {
				id
				name
			}
		}
	}
`;
const SURVEY_RESPONSES = gql`
	query (
		$where: SurveyResponseFilterInput
		$order: [SurveyResponseSortInput!]
	) {
		surveyResponses: allSurveyResponses(where: $where, order: $order) {
			id
			surveyId
			createdOn
			surveyAudience {
				name
				tag
				email
			}
			status {
				id
				name
			}
			response
			progress
		}
	}
`;
const SURVEY_SUMMARY_BY_ID = gql`
	query ($id: UUID!) {
		surveySummaryById(id: $id) {
			name
			error
			questionTags
			audienceTags
			questions {
				id
				name
				tag
			}
			groupedResponses {
				questionTag
				audienceTag
				questionId
				avgValue
				sum
				count
			}
		}
	}
`;
export {
  BASE_CONTACTS_LOOKUP,
  MANAGED_SURVEYS,
  MANAGED_SURVEYS_LOOKUP,
  MANAGED_SURVEY_AUDIENCE,
  MANAGED_SURVEY_BY_ID,
  SURVEY_BY_AUDIENCE_ID,
  SURVEY_BY_ID,
  SURVEY_RESPONSES,
  SURVEY_SUMMARY_BY_ID
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
